import fetch from 'auth/FetchInterceptor'

const AuthService = {}

AuthService.login = function (data) {
	return fetch({
		url: '/authenticate',
		method: 'post',
		data: data
	})
}

AuthService.register = function (data) {
	return fetch({
		url: '/register',
		method: 'post',
		data: data
	})
}

AuthService.sendOtp = function (data) {
	return fetch({
		url: '/register/send-otp',
		method: 'post',
		data: data
	})
}

AuthService.verifyOtp = function (data) {
	return fetch({
		url: '/register/verify-otp',
		method: 'post',
		data: data
	})
}

AuthService.sendLoginOtp = function (data) {
	return fetch({
		url: '/login/send-otp',
		method: 'post',
		data: data
	})
}

AuthService.verifyLoginOtp = function (data) {
	return fetch({
		url: '/login/verify-otp',
		method: 'post',
		data: data
	})
}

AuthService.refreshToken = function (data) {
	return fetch({
		url: '/refresh',
		method: 'post'
	})
}

export default AuthService;